<template>
  <nav class="z-10 fixed top-0 left-0 right-0 flex justify-between items-center h-[60px] px-4 md:px-6 backdrop-blur-sm drop-shadow-sm">
    <router-link to="/" class="text-xl flex items-center">
      <img src="@/assets/logo.svg" alt="INFLUME" class="object-contain mr-2 w-[50px] h-[50px]">
      <h1 class="font-bold hidden md:block">INFLUME</h1>
    </router-link>
    <div class="flex items-center gap-x-4 md:gap-x-10 text-sm md:text-lg">
      <a class="" href="/#Influencer" @click.prevent="scrollToSection('#Influencer')">Influencer</a>
      <a class="" href="/#Business" @click.prevent="scrollToSection('#Business')">Business</a>
      <o-button
        @click="showModel(false)"
        variant="primary"
        type="button"
        class="!bg-orange-200">
        <span>Join Now</span>
      </o-button>
      <div class="cursor-pointer" @click="showModel">Login</div>
    </div>
  </nav>
</template>

<script>
import LoginForm from '@/components/LoginForm.vue'
// import SignUpForm from '@/components/SignUpForm.vue'

export default {
  methods: {
    scrollToSection(selector) {
      this.$scrollTo(selector, 10, { offset: -100 })
    },
    showModel(isLogin = true) {
      if (isLogin) {
        this.$oruga.modal.open({
          component: LoginForm,
          // component: isLogin ? LoginForm : SignUpForm,
          trapFocus: true,
          contentClass: 'rounded-[2.5rem]',
          mobileClass: 'px-4'
        })
      } else {
        window.open('https://forms.gle/jKwc7WqxyhDpxJH67', '_blank')
      }
    },
  },
}
</script>
